document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var panelId = tab.getAttribute('data-tab');
      var scope = tab.closest('.section');
      scope.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('active'); });
      scope.querySelectorAll('.product-panel').forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      document.getElementById(panelId).classList.add('active');
    });
  });
});
